import { connect } from "react-redux";
import React, { useState } from "react";
import { InputNumber, Modal, Spin } from "antd";

import ConfirmButton from "../../../components/buttons/ConfirmButton";

import { setClientLimits } from "../../../modules/presence/api/api";
import { currentClientSelector } from "../../../redux/selectors/auth";

const ClientLimitForm = ({ getLimitsBonusesList, closeModal, token, client_id }) => {
  const [monthlyLimit, setMonthlyLimit] = useState(0);
  const [quarterlyLimit, setQuarterlyLimit] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const resetFields = () => {
    setMonthlyLimit(0);
    setQuarterlyLimit(0);
  };

  const handleDefineClientLimit = async () => {
    const dataToSend = {
      monthly_limit: monthlyLimit,
      quarterly_limit: quarterlyLimit,
      client_id
    };
    try {
      setIsLoading(true);
      await setClientLimits(dataToSend, token);
      resetFields();
      getLimitsBonusesList();
      closeModal();
      setIsLoading(false);
    } catch (e) {
      Modal.error({
        title: "Erreur",
        content: "Veuillez renseigner des champs valides"
      });
      setIsLoading(false);
      closeModal();
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant du plafond mensuel</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={monthlyLimit}
          onChange={setMonthlyLimit}
        />
      </div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant du plafond trimestriel</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={quarterlyLimit}
          onChange={setQuarterlyLimit}
        />
      </div>
      <div className="pt-6 flex justify-center mt-6">
        {isLoading ? (
          <Spin></Spin>
        ) : (
          <ConfirmButton label={"Appliquer au dossier"} large={true} onClick={() => handleDefineClientLimit()} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const client = currentClientSelector(state);
  return {
    token: state.auth.token,
    client_id: client.id
  };
};

export default connect(mapStateToProps)(ClientLimitForm);



// WEBPACK FOOTER //
// src/containers/admin/premium/ClientLimit.form.js